// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/XEicon/xeicon.min.css
// module id = KD64
// module chunks = 1